import React from "react";
import "./growl.scss"
import LayoutSidePad from "../layout/layout-parts/layout-side-pad";
import LayoutMaxWidth from "../layout/layout-parts/layout-max-width";

export default class Growl extends React.Component<{
  message: string;
}, {
  opacity: number;
  visible: boolean;
}> {

  constructor(props) {
    super(props);
    // Initial State
    this.state = {
      opacity: 1,
      visible: true 
    };
  }

  componentDidMount() {
    console.log('Growl componentDidMount()')
    setTimeout(() => {
      this.setState({
        opacity: 0
      }, () => {
        setTimeout(() => {
          this.setState({
            visible: false
          });
        }, 250);
      });
    }, 2000);
  }

  render() {

    if (!this.state.visible) {
      return null;
    }
    
    return (
      <div className='growl' style={{
        opacity: this.state.opacity
      }}>
        {/* <LayoutSidePad> */}
          {/* <LayoutMaxWidth> */}
            {/* <div className='growl-content'> */}
              {this.props.message}
            {/* </div> */}
          {/* </LayoutMaxWidth> */}
        {/* </LayoutSidePad> */}
      </div>
    );
  }

};